module.exports = __webpack_public_path__ + "b4cfadabd602ad78.png";